import { v4 } from "uuid";

export const updateInputs = (inputs, index, value) => {
    const newInputs = [...inputs.map((input, i) => (i === index ? { ...value, id: v4() } : { ...input, id: v4() }))];

    const accountInputs = newInputs.filter((input) => !input.place.customerId);
    const changedIndex = accountInputs.findIndex((accountInput) => accountInput.id === newInputs[index].id);

    const input = accountInputs[changedIndex];
    const nextInput = accountInputs[changedIndex + 1];

    if (nextInput) {
        if (input?.isSellAvg) {

            if (input?.amount && input.avg) {
                accountInputs[changedIndex + 1].amount = input.amount / input.avg;
            }
        } else {

            if (input?.amount && input.avg) {
                accountInputs[changedIndex + 1].amount = input.amount * input.avg;
            }
        }
    }


    const res = newInputs.map((input) => {
        const accountInput = accountInputs.find((input1) => input1.id === input.id);
        return accountInput || input;
    });
    return res;
};
